import { render, staticRenderFns } from "./buyCoupon.vue?vue&type=template&id=1ed9242b&scoped=true"
import script from "./buyCoupon.vue?vue&type=script&lang=js"
export * from "./buyCoupon.vue?vue&type=script&lang=js"
import style0 from "./buyCoupon.vue?vue&type=style&index=0&id=1ed9242b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9242b",
  null
  
)

export default component.exports